var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f1f5ff;}.b,.e{fill:none;}.b{stroke:#c8d1ec;}.c{fill:#c8d1ec;}.d{stroke:none;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 74,
    height: 74,
    rx: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.331 17.511)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(1.215)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 26.74,
    height: 25.525,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 0.5,
    y: 0.5,
    width: 25.74,
    height: 24.525,
    rx: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M24.468,31.823H21.752a1,1,0,0,1-1-1V28.306c-.336.006-.63.008-.923.008-.762,0-1.566-.014-2.418-.028l-.155,0h-.064c-.94-.016-1.913-.032-2.878-.032-.8,0-1.567.007-2.243.013h-.112c-.626.005-1.216.01-1.786.01-.677,0-1.212-.007-1.684-.021v2.57a1,1,0,0,1-1,1H4.774a1,1,0,0,1-1-1v-4.39c-1.512-2.848-1.125-6.315-.54-11.563v-.011c.062-.551.127-1.139.193-1.744l-.6-.291v1.021a1,1,0,0,1-1,1H1a1,1,0,0,1-1-1V10.185a1,1,0,0,1,1-1h.83a1,1,0,0,1,1,1v1.589l.7.342C4.22,5.5,4.864.989,5.762.442,6.233.155,11.079,0,15.4,0c3.629,0,8.025.116,8.474.442.852.619,1.457,5.942,1.984,11.6l.554-.27V10.185a1,1,0,0,1,1-1h.83a1,1,0,0,1,1,1v3.659a1,1,0,0,1-1,1h-.83a1,1,0,0,1-1-1V12.823l-.462.226.046.518.008.086c.09,1,.184,1.93.29,2.949.5,4.842.828,8.041-.825,9.911v4.31A1,1,0,0,1,24.468,31.823Zm.265-12.15a1.552,1.552,0,0,0-.717.207,19.817,19.817,0,0,0-2.151,1.293,4.6,4.6,0,0,1-1.36,3.4l3.511-.285c.018,0,1.777-.3,1.777-1.537V20.648C25.791,20.638,25.547,19.673,24.733,19.673Zm-20.146,0c-.812,0-1.058.965-1.061.975v2.105c0,1.235,1.76,1.534,1.778,1.537l3.511.285a4.575,4.575,0,0,1-1.361-3.4A19.868,19.868,0,0,0,5.3,19.879,1.552,1.552,0,0,0,4.587,19.673ZM9.9,23.334a.472.472,0,1,0,0,.943h9.433a.472.472,0,0,0,0-.943Zm-.943-1.887a.472.472,0,1,0,0,.943H20.281a.472.472,0,1,0,0-.943ZM6.026,6.355a.944.944,0,0,0-.943.943l-.841,6.659a.943.943,0,0,0,.944.943H24.212a.944.944,0,0,0,.943-.943L24.326,7.3a.945.945,0,0,0-.943-.943Z",
    transform: "translate(0 5.856)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.104f982cffcd1043d85c13bc0b0291ab.svg";
export { ForwardRef as ReactComponent };